import { connect } from "react-redux";
import { Link, useLocation, Navigate, Route, Routes } from "react-router-dom";
import AdvisorStats from "./AdvisorStats";

const tabs = [
	{
		link: "/advisor/dashboard/stats",
		name: "Stats",
	},
];

const AdvisorDashboard = ({}) => {
	const location = useLocation();
	const currentTab = location.pathname;

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Bureau Dashboard</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs-alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								{/* <Link to={tab.link}>{tab.name}</Link> */}
							</li>
						);
					})}
				</ul>

				<Routes>
					{
						<Route
							path="/stats"
							element={<AdvisorStats />}
						/>
					}
					<Route
						path="*"
						element={
							<Navigate
								to="/advisor/dashboard/stats"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorDashboard);
